import { render, staticRenderFns } from "./ResursDetalji.vue?vue&type=template&id=013436db&"
import script from "./ResursDetalji.vue?vue&type=script&lang=js&"
export * from "./ResursDetalji.vue?vue&type=script&lang=js&"
import style0 from "./ResursDetalji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports